// extracted by mini-css-extract-plugin
module.exports = {"para":"HomeContent_para__Ez7Lz","keyDetails":"HomeContent_keyDetails__1rs13","keySummary":"HomeContent_keySummary__2grfw"};